import {
  FEATURE_FLAGS_BY_USER_GET,
  FEATURE_FLAGS_BY_USER_GET_FULFILLED,
  FEATURE_FLAGS_BY_USER_GET_REJECTED,
  FEATURE_FLAGS_BY_USER_GET_RESET
} from './actions'
import { IFeatureFlagStore } from './interface'
import { IReducerAction } from '../interface'

const featureFlagsInitialState: IFeatureFlagStore = {
  flagsList: {
    data: [],
    isLoading: false
  }
}

const featureFlagsReducer = (state: IFeatureFlagStore, { data, type }: IReducerAction) => {
  switch (type) {
    case FEATURE_FLAGS_BY_USER_GET:
      return {
        ...state,
        flagsList: {
          ...state.flagsList,
          data: [],
          isLoading: true
        }
      }
    case FEATURE_FLAGS_BY_USER_GET_FULFILLED:
      return {
        ...state,
        flagsList: {
          ...state.flagsList,
          data,
          isLoading: false
        }
      }
    case FEATURE_FLAGS_BY_USER_GET_REJECTED:
      return {
        ...state,
        flagsList: {
          ...state.flagsList,
          data: [],
          error: data,
          isLoading: false
        }
      }
    case FEATURE_FLAGS_BY_USER_GET_RESET:
      return featureFlagsInitialState
    default:
      return state
  }
}
export default featureFlagsReducer
